import * as React from 'react'
import { useAuthContext } from 'providers/AuthProvider'
import SuccessPage from 'views/SuccessPage'
import { useLocation } from 'react-router-dom'

interface AccountSuccessProps {}

const AccountSuccess: React.FunctionComponent<AccountSuccessProps> = () => 
{
  const location = useLocation()
  const { signinRedirect } = useAuthContext()
  const redirectSib = () => {
    window.location.href = process.env.REACT_APP_REDIRECT_URL_SIB
  }

  const redirect = location.state === 'administrator' ? redirectSib : signinRedirect

  const title = 'Creaste tu cuenta con éxito'
  const pretitle = '¡Listo!'
  const subtitle = 'Para comenzar a operar, iniciá sesión en la plataforma de Interbanking.'
  

  return (
    <SuccessPage title={title} subtitle={subtitle} action={redirect} pretitle={pretitle} />
  )
}

export default AccountSuccess
